/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_3_NoteInputs */

const en_mk_agent_3_note = /** @type {(inputs: Mk_Agent_3_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An agent only reads the channels it is allowed to read. Private channels and direct messages stay closed unless the agent is explicitly given access.`)
};

const id_mk_agent_3_note = /** @type {(inputs: Mk_Agent_3_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen hanya membaca channel yang memang boleh ia baca. Channel privat dan pesan langsung tetap tertutup kecuali agennya diberi akses eksplisit.`)
};

/**
* | output |
* | --- |
* | "An agent only reads the channels it is allowed to read. Private channels and direct messages stay closed unless the agent is explicitly given access." |
*
* @param {Mk_Agent_3_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_3_note = /** @type {((inputs?: Mk_Agent_3_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_3_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_3_note(inputs)
	return en_mk_agent_3_note(inputs)
});